document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-size-chart] [data-unit]');
  if (!button) return;

  const root = button.closest('[data-size-chart]');
  if (!root) return;

  const unit = button.dataset.unit;
  const buttons = root.querySelectorAll('[data-unit]');
  const tables = root.querySelectorAll('[data-table]');

  buttons.forEach((btn) => {
    btn.classList.toggle('active', btn.dataset.unit === unit);
  });

  tables.forEach((table) => {
    table.classList.toggle('active', table.dataset.table === unit);
  });
});